import { render, staticRenderFns } from "./account-su-updates-list.html?vue&type=template&id=4c03bc56&scoped=true&external"
import script from "./account-su-updates-list.js?vue&type=script&lang=js&external"
export * from "./account-su-updates-list.js?vue&type=script&lang=js&external"
import style0 from "./account-su-updates-list.scss?vue&type=style&index=0&id=4c03bc56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03bc56",
  null
  
)

export default component.exports